import { FC } from 'react';
import { Tr } from '@utils';
import { CarListBand } from '@services';
import { Card, CardProps, Stack, Typography } from '@mui/material';
import { FilterChipButton } from '@components/common';

export interface IVehicleSuggestionListCarBandListFilterProps extends CardProps {
	carListBands: CarListBand[];
	selectedCarListBands: string[];
	onSelectChange?: (selected: string[]) => void;
}

export const VehicleSuggestionListCarBandListFilter: FC<IVehicleSuggestionListCarBandListFilterProps> = ({
	carListBands,
	selectedCarListBands,
	onSelectChange,
	sx,
	...props
}) => {
	return (
		<Card variant="outlined" sx={{ width: 1.0, paddingX: 4, paddingTop: 2, paddingBottom: 3, ...sx }} {...props}>
			<Stack direction="column" spacing={2}>
				<Typography>
					<Tr.Portal path="dashboard.vehicle-suggestions.filter-description" />
				</Typography>
				<Stack direction="row" spacing={3}>
					{carListBands.map(({ label, id }, i) => {
						const isSelected = selectedCarListBands.some((carListBandId) => carListBandId === id);
						return (
							<FilterChipButton
								data-testid="vehicle-suggestion-list-filter-button"
								key={`car-list-band-filter-${id}-${i}`}
								active={isSelected}
								onClick={() => onSelectChange?.([...new Set([...selectedCarListBands, id])])}
								onRemove={() => onSelectChange?.(selectedCarListBands.filter((carListBandId) => carListBandId !== id))}
							>
								{label}
							</FilterChipButton>
						);
					})}
				</Stack>
			</Stack>
		</Card>
	);
};
